import React, { useState } from 'react';
import { Navbar, Nav, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-scroll'; // Import Link from react-scroll
import logo from "../Images/logoI.png";
import "./Navigation.css";

function CustomNavbar() {
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const handleOffcanvasClose = () => setShowOffcanvas(false);
    const handleOffcanvasToggle = () => setShowOffcanvas(!showOffcanvas);

    return (
        <>
            <Navbar expand="lg" className="custom-navbar">
                <Navbar.Brand as={Link} to="landingPage" smooth={true} duration={500}>
                    <img src={logo} alt="navLogo" className="navLogo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleOffcanvasToggle} />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Link as={Link} to="secTwo" smooth={true} duration={500}>My Works</Nav.Link>
                        <Nav.Link as={Link} to="secFive" smooth={true} duration={500}>My Capabilities</Nav.Link>
                        <Nav.Link as={Link} to="technologiesSection" smooth={true} duration={500}>Technologies</Nav.Link>
                        <Nav.Link as={Link} to="aboutMeSection" smooth={true} duration={500}>About Me</Nav.Link>
                        <Nav.Link as={Link} to="contactMeSec" smooth={true} duration={500}>Contact Me</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <Offcanvas show={showOffcanvas} onHide={handleOffcanvasClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Isuru Nirash</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <Nav.Link as={Link} to="secTwo" smooth={true} duration={500} onClick={handleOffcanvasClose}>My Works</Nav.Link>
                        <Nav.Link as={Link} to="secFive" smooth={true} duration={500} onClick={handleOffcanvasClose}>My Capabilities</Nav.Link>
                        <Nav.Link as={Link} to="technologiesSection" smooth={true} duration={500} onClick={handleOffcanvasClose}>Technologies</Nav.Link>
                        <Nav.Link as={Link} to="aboutMeSection" smooth={true} duration={500} onClick={handleOffcanvasClose}>About Me</Nav.Link>
                        <Nav.Link as={Link} to="contactMeSec" smooth={true} duration={500} onClick={handleOffcanvasClose}>Contact Me</Nav.Link>
                    </Nav>
                </Offcanvas.Body>

            </Offcanvas>
        </>
    );
}

export default CustomNavbar;
